<div class="container">
  <!-- <prettyjson [obj]="addressForm.value"></prettyjson> -->
  <form [formGroup]="addressForm">
    <h1 class="text-center">{{ data ? 'Edit Hospital Information' : 'Add Hospital Information' }}</h1>
    <mat-card class="m-2 p-2">
      <div class="row">
        <div class="col-md-8">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Hospital Name</mat-label>
            <input matInput formControlName="hospitalName">
            <mat-error *ngIf="addressForm.get('hospitalName')?.invalid">
              <span *ngIf="addressForm.get('hospitalName')?.errors?.required">*Hospital Name is required.</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Short Name</mat-label>
            <input matInput formControlName="shortName">
            <mat-error *ngIf="addressForm.get('shortName')?.invalid">
              <span *ngIf="addressForm.get('shortName')?.errors?.required">*Short Name is required.</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-12">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Website Link</mat-label>
            <input matInput formControlName="websiteLink">
            <mat-error *ngIf="addressForm.get('websiteLink')?.invalid">
              <span *ngIf="addressForm.get('websiteLink')?.errors?.required">*Website Link is required.</span>
              <mat-error *ngIf="addressForm.get('websiteLink')?.hasError('pattern')">
                *Please enter a valid URL (must start with 21http:// or https://).
              </mat-error>
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <hr>
      <div class="row">
        <ng-container formArrayName="drDetails">
          <div *ngFor="let dr of drDetail.controls; let i = index" [formGroupName]="i">
            <p>Doctor Details {{ i + 1 }}</p>
            <div class="row">
              <div class="col-md-4">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Doctor's Name</mat-label>
                  <input matInput formControlName="doctorsName">
                  <mat-error *ngIf="dr.get('doctorsName')?.invalid">
                    <span *ngIf="dr.get('doctorsName')?.errors?.required">*It is required.</span>
                    <span *ngIf="dr.get('doctorsName')?.errors?.pattern">*Enter only characters.</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Designation</mat-label>
                  <mat-select formControlName="designation">
                    <mat-option *ngFor="let d of drDesignation$ | async" [value]="d">{{ d }}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="dr.get('designation')?.errors?.required">At least one designation is required.
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Dr. Contact Number</mat-label>
                  <input type="number" maxlength="10" matInput formControlName="phoneNo" />
                  <mat-error *ngIf="dr.get('phoneNo')?.invalid">
                    <span *ngIf="dr.get('phoneNo')?.errors?.required">*It is required.</span>
                    <span *ngIf="dr.get('phoneNo')?.errors?.pattern">*Enter a valid 10-digit number.</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" type="email" required />
                  <mat-error *ngIf="dr.get('email')?.errors?.required">Email is required</mat-error>
                  <mat-error *ngIf="dr.get('email')?.errors?.required">Enter a valid email</mat-error>
                </mat-form-field>
              </div>

            </div>
            <div class="col-md-4 d-flex gap-2 mb-4">
              <button mat-raised-button color="warn" (click)="removeDrDetail(i,dr)" *ngIf="drDetail.length > 1">Remove
              </button>
              <button mat-raised-button color="primary" (click)="addDrDetail()" [disabled]="dr.invalid">Add Dr</button>
            </div>
          </div>
        </ng-container>
        <hr>
      </div>
      <div class="row">
        <ng-container formArrayName="socialWorkerDetails">
          <div *ngFor="let w of socialWorkerDetail.controls; let i = index" [formGroupName]="i">
            <p>MSW Details {{ i + 1 }}</p>
            <div class="row">
              <!-- Social Worker Name -->
              <div class="col-md-4">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Medical MSW Name</mat-label>
                  <input matInput formControlName="socialWorkerName">
                  <mat-error *ngIf="w.get('socialWorkerName')?.invalid">
                    <span *ngIf="w.get('socialWorkerName')?.errors?.pattern">*Enter only characters.</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- Contact Number -->
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>MSW Contact Number</mat-label>
                  <input matInput type="number" maxlength="10" formControlName="phoneNo" />
                  <mat-error *ngIf="w.get('phoneNo')?.invalid">
                    <span *ngIf="w.get('phoneNo')?.errors?.pattern">*Enter a valid 10-digit number.</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" type="email" />
                  <mat-error *ngIf="w.get('email')?.errors?.pattern">Enter a valid email</mat-error>
                </mat-form-field>
              </div>
              <!-- Buttons -->
              <div class="d-flex gap-2 mb-4 col-md-4">
                <button mat-raised-button color="warn" (click)="removeSocialWorkerDetail(i)"
                  *ngIf="socialWorkerDetail.length > 1">Remove
                </button>
                <button mat-raised-button color="primary" (click)="addSocialWorkerDetail()" [disabled]="w.invalid">Add
                  MSW
                </button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <hr>
      <div class="row">
        <ng-container formArrayName="adminDetails">
          <div *ngFor="let admin of adminDetail.controls; let i = index" [formGroupName]="i">
            <p>Administration Details {{ i + 1 }}</p>
            <div class="row">
              <!-- Name -->
              <div class="col-md-3">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Name</mat-label>
                  <input matInput formControlName="name">
                  <mat-error *ngIf="admin.get('name')?.invalid">
                    <span *ngIf="admin.get('name')?.errors?.pattern">*Enter only characters.</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- Designation -->
              <div class="col-md-3">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Designation</mat-label>
                  <mat-select formControlName="designation">
                    <mat-option value="Assistant">Assistant</mat-option>
                    <mat-option value="Admin">Admin</mat-option>
                    <mat-option value="Manager">Manager</mat-option>
                    <mat-option value="Dean">Dean</mat-option>
                    <mat-option value="Other">Other (Specify)</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Custom Designation -->
              <div class="col-md-2" *ngIf="admin.get('designation')?.value === 'Other'">
                <mat-form-field class="full-width" appearance="outline">
                  <mat-label>Custom Designation</mat-label>
                  <input matInput formControlName="customDesignation">
                </mat-form-field>
              </div>
              <!-- Contact Number -->
              <div class="col-md-2" [ngClass]="{'col-md-3': admin.get('designation')?.value !== 'Other'}">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Contact Number</mat-label>
                  <input matInput type="number" maxlength="10" formControlName="phoneNo" />
                  <mat-error *ngIf="admin.get('phoneNo')?.invalid">
                    <span *ngIf="admin.get('phoneNo')?.errors?.pattern">*Enter a valid 10-digit number.</span>
                  </mat-error>
                </mat-form-field>
              </div>
              <!-- Email -->
              <div class="col-md-2" [ngClass]="{'col-md-3': admin.get('designation')?.value !== 'Other'}">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" type="email" />
                  <mat-error *ngIf="admin.get('email')?.errors?.pattern">Enter a valid email</mat-error>
                </mat-form-field>
              </div>
              <!-- Buttons -->
              <div class="d-flex gap-2 mb-4 col-md-12">
                <button mat-raised-button color="warn" (click)="removeAdminDetail(i)"
                  *ngIf="adminDetail.length > 1">Remove
                </button>
                <button mat-raised-button color="primary" (click)="addAdminDetail()" [disabled]="admin.invalid">Add
                  Administration</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <hr>
      <div class="row">
        <mat-label>Hospital Address</mat-label>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Hospital Address</mat-label>
          <textarea matInput placeholder="Hospital Address" formControlName="address"></textarea>
          <mat-error *ngIf="addressForm.get('address')?.invalid">
            <span *ngIf="addressForm.get('address')?.errors?.required">Address is required.</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="row">
        <div class="col-md-4">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>City</mat-label>
            <input matInput formControlName="city">
            <mat-error *ngIf="addressForm.get('city')?.invalid">
              <span *ngIf="addressForm.get('city')?.errors?.required">*City is required.</span>
              <span *ngIf="addressForm.get('city')?.errors?.pattern">*Enter only characters.</span>
            </mat-error>
          </mat-form-field>
        </div>

        <div class="col-md-4">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>State</mat-label>
            <mat-select formControlName="state">
              <mat-option *ngFor="let state of mState" [value]="state.name">{{ state.name }}</mat-option>
            </mat-select>
            <mat-error *ngIf="addressForm.get('state')?.invalid">
              <span *ngIf="addressForm.get('state')?.errors?.required">*State is required.</span>
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-md-4">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Pin Code</mat-label>
            <input matInput #postalCode maxlength="6" type="text" formControlName="zipcode">
            <mat-hint align="end">{{ postalCode.value.length }} / 6</mat-hint>
            <mat-error *ngIf="addressForm.get('zipcode')?.invalid">
              <span *ngIf="addressForm.get('zipcode')?.errors?.required">*Pin Code is required.</span>
              <span *ngIf="addressForm.get('zipcode')?.errors?.minlength">*Must be 6 digits.</span>
              <span *ngIf="addressForm.get('zipcode')?.errors?.pattern">*Only numbers allowed.</span>
            </mat-error>
          </mat-form-field>
        </div>


        <div class="col-md-12" formArrayName="notes">
          <div *ngFor="let note of notes.controls; let i = index" [formGroupName]="i" class="mb-3">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Notes</mat-label>
              <textarea matInput placeholder="notes" formControlName="remark"></textarea>
              <span *ngIf="note.get('remark')?.errors?.required && note.get('remark')?.touched">Remark is
                required.</span>
            </mat-form-field>
            <!-- Remove button -->
            <div class="justify-content-start d-flex gap-2">
              <button mat-raised-button color="warn" *ngIf="notes.length > 1" (click)="removeNote(i)">Remove Note
              </button>
              <button mat-raised-button color="primary" [disabled]="note.invalid" (click)="addNote()">Add Another Note
              </button>
            </div>
          </div>
          <!-- Add Note button -->
        </div>
        <div class="row">
          <h4>Assign Center</h4>
          <mat-form-field appearance="outline" class="col-md-6">
            <mat-label>For Centres</mat-label>

            <mat-select #selectElement formControlName="forCentres" multiple>

              <app-select-all [matSelect]="selectElement"></app-select-all>

              <mat-select-trigger>
                <ng-container *ngIf="selectElement.value?.length; else noSelection">

                  <span *ngFor="let centre of selectElement.value.slice(0,2); let i = index">
                    {{ centre }}
                    <span *ngIf="i < 1 && selectElement.value.length > 1">, </span>
                  </span>

                  <span *ngIf="selectElement.value.length > 2" style="color:#1976d2; font-weight:500;">
                    (+{{ selectElement.value.length - 2 }} more)
                  </span>

                </ng-container>

                <ng-template #noSelection>
                  Select Centre
                </ng-template>
              </mat-select-trigger>

              <!-- Dynamic Centres -->
              <mat-option *ngFor="let c of (centres$ | async)" [value]="c.centreCode">
                {{ c.centreName }}
              </mat-option>
              <!-- Extra Static Values -->
              <mat-option value="Initiated">Initiated</mat-option>
              <mat-option value="Others">Others</mat-option>


            </mat-select>
          </mat-form-field>
        </div>

      </div>
      <hr>
      <div class="justify-content-center d-flex gap-2">
        <button mat-raised-button color="accent" type="button" (click)="onCancel()">Cancel</button>
        <button mat-raised-button color="primary" type="submit" (click)="onSubmit()" [disabled]="addressForm.invalid || isLoading">{{
          data ? 'Update' : 'Submit' }}
        </button>
      </div>
    </mat-card>
  </form>
</div>

<!-- Loader Spinner (only visible while loading) -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>